export const LOGIN_EVENT_STORAGE_PREFIX = 'ollie:login_event_fired:';

const inFlightLoginEvents = new Set();

export const createLoginEventId = (shopifyId, expiresAt) =>
  `${shopifyId}:${expiresAt}`;

export const getLoginEventStorageKey = loginEventId =>
  `${LOGIN_EVENT_STORAGE_PREFIX}${loginEventId}`;

export const loginSuccessfulEvent = ({ analyticsId, customerId }) => ({
  type: '[Login] Login successful',
  data: {
    analyticsId,
    customerId,
  },
});

// Skip only when retrieve explicitly says there is no active subscription.
// Missing is_active (API before that field ships) still tracks.
export const shouldTrackLoginForCustomer = isActive => isActive !== false;

export const shouldFireLoginEvent = (
  loginEventId,
  storage = typeof localStorage === 'undefined' ? undefined : localStorage,
) => {
  if (!loginEventId || typeof storage?.getItem !== 'function') {
    return false;
  }
  return storage.getItem(getLoginEventStorageKey(loginEventId)) !== '1';
};

export const markLoginEventFired = (
  loginEventId,
  storage = typeof localStorage === 'undefined' ? undefined : localStorage,
) => {
  if (!loginEventId || typeof storage?.setItem !== 'function') {
    return;
  }
  storage.setItem(getLoginEventStorageKey(loginEventId), '1');
};

export const consumePendingLoginEvent = async ({
  loginEventPending,
  loginEventId,
  customer,
  reporter,
  storage = typeof localStorage === 'undefined' ? undefined : localStorage,
}) => {
  if (
    !loginEventPending ||
    !loginEventId ||
    !customer?.id ||
    !shouldTrackLoginForCustomer(customer.is_active)
  ) {
    return false;
  }
  if (
    !shouldFireLoginEvent(loginEventId, storage) ||
    inFlightLoginEvents.has(loginEventId)
  ) {
    return false;
  }

  inFlightLoginEvents.add(loginEventId);
  try {
    await reporter.tag(
      loginSuccessfulEvent({
        analyticsId: customer.analytics_id,
        customerId: customer.id,
      }),
    );
    markLoginEventFired(loginEventId, storage);
    return true;
  } catch {
    return false;
  } finally {
    inFlightLoginEvents.delete(loginEventId);
  }
};
